import React, { useRef } from "react";
import { Modal, Button, Space, message } from "antd";
import { ExclamationCircleFilled, CopyOutlined } from "@ant-design/icons";
import { InjectBaseModalProps } from "@/hooks/Modal/ModalStore";
import OrderDTO from "@/dto/order/OrderDTO";
import { openUrl, uuid } from "@/utils";
import { select } from "@/utils/dom";
import copy from "copy-to-clipboard";

interface WiredOrderTipModalProps extends InjectBaseModalProps {
    wiredOrders: OrderDTO[];
    onNext: () => void;
    onStop: () => void;
}

const WiredOrderTipModal: React.FC<WiredOrderTipModalProps> = (props) => {
    const { open, wiredOrders, onNext, onStop, onCancel } = props;

    // 模拟订单数据
    const orderOriginalIds = wiredOrders.map(({ originalId }) => originalId);
    const text = orderOriginalIds.join(", ");
    const id = useRef(uuid()).current;

    return (
        <div style={{ padding: "20px", background: "#f5f5f5", minHeight: "100vh" }}>
            <Modal
                open={open}
                title={null}
                footer={null}
                width={600}
                styles={{ body: { padding: "32px 32px 24px" } }}
                closable={false}
            >
                <div style={{ display: "flex", alignItems: "flex-start" }}>
                    <ExclamationCircleFilled
                        style={{ fontSize: "22px", color: "#faad14", marginRight: "16px", marginTop: "2px" }}
                    />

                    <div style={{ flex: 1 }}>
                        <div
                            style={{
                                fontSize: "16px",
                                fontWeight: 500,
                                color: "rgba(0, 0, 0, 0.85)",
                                marginBottom: "16px",
                                lineHeight: "1.5",
                            }}
                        >
                            部分订单数据异常，已自动过滤选择，请联系客服处理数据异常订单，其他订单可正常打印
                        </div>

                        <div
                            style={{
                                backgroundColor: "#f4f6f8",
                                borderRadius: "4px",
                                padding: "16px",
                                marginBottom: "24px",
                            }}
                        >
                            <div style={{ marginBottom: "8px", display: "flex", alignItems: "center" }}>
                                <span style={{ fontWeight: "bold", color: "rgba(0, 0, 0, 0.85)", marginRight: "4px" }}>
                                    异常数据订单
                                </span>
                                <CopyOutlined
                                    style={{ color: "#1890ff", cursor: "pointer" }}
                                    onClick={() => {
                                        select(document.getElementById(id));

                                        copy(text);

                                        message.success("复制成功");
                                    }}
                                />
                            </div>
                            <div id={id} style={{ color: "#8c8c8c", wordBreak: "break-all", lineHeight: "2" }}>
                                {text}
                            </div>
                        </div>

                        <div style={{ display: "flex", justifyContent: "flex-end" }}>
                            <Space size="middle">
                                <Button
                                    onClick={() => {
                                        onStop();
                                        onCancel();
                                    }}
                                >
                                    取消
                                </Button>
                                <Button
                                    onClick={() => {
                                        openUrl("https://v2.fahuoyi.com/cs");
                                    }}
                                >
                                    联系客服
                                </Button>
                                <Button
                                    type="primary"
                                    onClick={() => {
                                        onNext();
                                        onCancel();
                                    }}
                                >
                                    继续打印(已排除异常数据订单)
                                </Button>
                            </Space>
                        </div>
                    </div>
                </div>
            </Modal>
        </div>
    );
};

export default WiredOrderTipModal;
